import { keyframes, styled } from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  width: 400px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

export const FarmerImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: center;
`;

export const FarmerInfo = styled.div`
  padding: 15px;
`;

export const FarmerName = styled.h3`
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const Box = styled.div`
  display: flex;
  justify-content: start;
  gap: 20px;
`;

export const FarmerDetails = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  border-right: 1px solid #d9d6cf;
  padding-right: 30px;
  &:last-child {
    border: none;
    padding-right: 0;
  }
  p {
    margin: 0;
  }
`;

const dotsAnimation = keyframes`
  20% {
    background-position: 0% 0%, 50% 50%, 100% 50%;
  }
  40% {
    background-position: 0% 100%, 50% 0%, 100% 50%;
  }
  60% {
    background-position: 0% 50%, 50% 100%, 100% 0%;
  }
  80% {
    background-position: 0% 50%, 50% 50%, 100% 100%;
  }
`;

export const Dots = styled.div`
  position: absolute;
  width: 44px;
  height: 21.1px;
  background:
    radial-gradient(circle closest-side, #e5007d 90%, #0000) 0% 50%,
    radial-gradient(circle closest-side, #e5007d 90%, #0000) 50% 50%,
    radial-gradient(circle closest-side, #e5007d 90%, #0000) 100% 50%;
  background-size: calc(100% / 3) 10px;
  background-repeat: no-repeat;
  animation: ${dotsAnimation} 0.8s infinite linear;
`;

export const FID = styled.b`
  color: #e5007d;
`;

export const Wrapper = styled.div`
  position: relative;
  top: 30%;
  left: 45%;
`;
